(() => {
  const init = scope => {
    scope.querySelectorAll('[data-research-library]').forEach(root => {
      if(root.dataset.ready) return; root.dataset.ready='true';
      const search=root.querySelector('[data-library-search]'), filter=root.querySelector('[data-library-category]');
      const cards=[...root.querySelectorAll('[data-library-card]')];
      const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');
      const update=()=>{let count=0;cards.forEach(c=>{const match=norm(c.dataset.name).includes(norm(search.value))&&(!filter.value||c.dataset.category===filter.value);c.hidden=!match;if(match)count++;});root.querySelector('[data-library-count]').textContent=count+' dossier'+(count>1?'s':'');root.querySelector('[data-library-empty]').hidden=count!==0;};
      search.addEventListener('input',update);filter.addEventListener('change',update);
    });
    scope.querySelectorAll('[data-research-document]').forEach(root=>{
      const expand=root.querySelector('[data-erl-expand]'),collapse=root.querySelector('[data-erl-collapse]');
      if(!expand||expand.dataset.ready) return;expand.dataset.ready='true';
      expand.addEventListener('click',()=>root.querySelectorAll('details').forEach(d=>d.open=true));
      collapse.addEventListener('click',()=>root.querySelectorAll('details').forEach(d=>d.open=false));
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
